import { useTranslation } from "react-i18next";
import icon from "../../images/phone-call.svg";
import { AnimatedOnScroll } from "react-animated-css-onscroll";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import { Image } from "@imagekit/react";

const About2 = ({ detail = false }) => {
  const { t } = useTranslation("about");
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const bio = t("founder.bio", { returnObjects: true });

  return (
    <section className="about-section-s2">
      <div className="container">
        <div className="wrap">
          <AnimatedOnScroll animationIn="fadeInUp">
            <div className={"row" + (!detail ? " align-items-center" : "")}>
              <div className="col-lg-6 col-12">
                <div className="image">
                  <Image
                    src={"/Mohammed_Attaoui.jpeg"}
                    transformation={[
                      {
                        width: "590",
                        height: "740",
                        crop: "maintain_ratio",
                        focus: "auto",
                      },
                    ]}
                    alt="about"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-12">
                <div className="content ">
                  <div className="section-title">
                    <h2 className="">{t("intro.whoWeAre")}</h2>
                    <h3 className="">{t("intro.orgName")}</h3>
                    <p className="text-start">{t("intro.body")}</p>
                  </div>
                  {!detail && (
                    <div className="about-bottom">
                      <LocalizedLink
                        onClick={ClickHandler}
                        to={"/about"}
                        className="theme-btn"
                      >
                        {t("intro.discover")}
                      </LocalizedLink>
                      <div className="call">
                        <div className="icon">
                          <img src={icon} alt="" />
                        </div>
                        <div className="text">
                          <span>{t("intro.callUs")}</span>
                          <a dir="ltr" href="tel:+212658152486">
                            +(212) 658-152 486
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </AnimatedOnScroll>
        </div>
      </div>
      {detail && (
        <div className="container">
          <div className="wrap">
            <div className={"row align-items-center justify-content-center"}>
              <div className="col-lg-8 col-12">
                <div className="section-title">
                  <h2 className="">{t("founder.heading")}</h2>
                  <h3 className="">{t("founder.name")}</h3>
                  <div>
                    <p className="">{t("founder.fullName")}</p>
                    <p className="mb-3">{t("founder.birth")}</p>

                    <ul className="list-group m-0 p-0">
                      {(Array.isArray(bio) ? bio : []).map((line, i) => (
                        <li className="list-group-item" key={i}>
                          <p className="text-start">{line}</p>
                        </li>
                      ))}
                    </ul>
                    <p className="mt-3">{t("founder.death")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default About2;
